// @ts-nocheck
export interface QueryString {
    [key: string]: string;
}

export const getBuiltQueryString = (link: string, queryString: QueryString[]) => {
    let _link = link;

    if (queryString.length === 0) {
        return;
    }

    for (const [index, obj] of queryString.entries()) {
        index === 0 ? (_link += `?`) : (_link += `&`);
        _link += `${Object.keys(obj)[0]}=${Object.values(obj)[0]}`;
    }

    return _link;
};
